// ----------------- [ A4D Settings :: GETTERS ] ----------------- //

import {get} from "lodash-es";

export const getters = {

    'GET_SETTING' : (state) => (name) => {
        return get(state, name, undefined);
    },
    'test_mode' : (state) => {
        return state.test_mode;
    }

};
